import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from '../layout/navbar/Navbar';
import Login from '../pages/authentication/login/Login';
import Register from '../pages/authentication/register/Register';
import ResetPassword from '../pages/authentication/reset-password/ResetPassword';
import AddUsers from '../pages/common-components/common-forms/add-users/AddUsers';
import Setting from '../pages/document-management/settings/Setting';
import TabsSection from '../pages/document-management/document-tabs/TabsSection';

import Version from '../pages/document-management/documents/Version';
import AccountChart from '../pages/AccountChart';
import {
  ProtectedRouteForSA,
  ProtectedRouteForAdminAndUser,
  ProtectedRouteForAllRole,
  ProtectedRouteForLoggedInUser,
  ProtectedRouteForOtp,
  ProtectedRouteForAdmin,
  ConfigurePageAfterAppRun,
  ProtectedRouteForSalesAdmin,
} from './protected-routes/ProtectedRoutes-RoleBased';
import PageNotFound from '../pages/utils/PageNotFound';
import DocumentAnnotation from '../pages/document-management/document-annotation/DocumentAnnotation';
import { MainRoot, globalClasses } from '../pages/utils/globalUtils';
import AccountInfoTabSection from '../pages/accountInfo/AccountInfoTabSection';
import Payment from '../pages/superadmin-dashboard/payment-history/Payment';
import SalesReport from '../pages/superadmin-dashboard/dashboard/SalesReport';
import Subscriber from '../pages/superadmin-dashboard/subscriber/Subscriber';
import Notification from '../pages/notifications/Notification';
import OrganizationScanHistory from '../pages/superadmin-dashboard/organizations-scan-history/OrganizationScanHistory';
import OtpSection from '../pages/authentication/two-factor-auth/OtpSection';
import SuperManager from '../pages/superadmin-dashboard/my-team/SuperManager';
import MainLayout from '../layout/main-layout/MainLayout';
import MyAccount from '../pages/superadmin-dashboard/my-account/MyAccount';
import LogDashboard from '../pages/document-management/flow-configuration/LogDashboard';
import FlowConfiguration from '../pages/document-management/flow-configuration/FlowConfiguration';
import AdminDashboardNew from '../pages/admin-dashboard/AdminDashboardNew';
import Support from '../pages/support/Support';
import FlowConfigurationEditor from '../pages/document-management/flow-configuration/FlowConfigurationEditor';
import Help from '../pages/help/Help';
import AccuracyDetails from '../pages/superadmin-dashboard/accuracy-details/AccuracyDetails';
import SubscriptionPlan from '../pages/superadmin-dashboard/subscription-plan/SubscriptionPlan';
import ActivityHistory from '../pages/superadmin-dashboard/activity-history/ActivityHistory';
import SalesAdminDashboard from '../pages/sales-admin-dashboard/SalesAdminDashboard';
import TermsOfService from '../pages/help/TermsOfService';

const Router = () => (
  <BrowserRouter>
    <MainRoot className={globalClasses.root}>
      <Routes>
        <Route element={<ProtectedRouteForAdminAndUser />}>
          <Route
            path="/"
            element={
              <MainLayout>
                <ConfigurePageAfterAppRun />
              </MainLayout>
            }
          />
          <Route
            path="/invoices"
            element={
              <MainLayout>
                <TabsSection key="invoices" />
              </MainLayout>
            }
          />
          <Route
            path="/direct-expense"
            element={
              <MainLayout>
                <TabsSection key="invoices" />
              </MainLayout>
            }
          />
          <Route
            path="/receipts"
            element={
              <MainLayout>
                <TabsSection key="receipts" />
              </MainLayout>
            }
          />
          <Route
            path="/sales"
            element={
              <MainLayout>
                <TabsSection key="sales" />
              </MainLayout>
            }
          />
          <Route
            path="/bank-statements"
            element={
              <MainLayout>
                <TabsSection key="bank-statements" />
              </MainLayout>
            }
          />
          <Route
            path="/bank-statements/:id"
            element={
              <MainLayout>
                <TabsSection key="bank-statements" />
              </MainLayout>
            }
          />
          <Route
            path="/creditcardstatements"
            element={
              <MainLayout>
                <TabsSection key="creditcardstatements" />
              </MainLayout>
            }
          />
          <Route
            path="/creditcardstatements/:id"
            element={
              <MainLayout>
                <TabsSection key="creditcardstatements" />
              </MainLayout>
            }
          />
          <Route
            path="/invoices/:id"
            element={
              <MainLayout>
                <TabsSection key="invoices" />
              </MainLayout>
            }
          />
          <Route
            path="/receipts/:id"
            element={
              <MainLayout>
                <TabsSection key="receipts" />
              </MainLayout>
            }
          />
          <Route
            path="/sales/:id"
            element={
              <MainLayout>
                <TabsSection key="sales" />
              </MainLayout>
            }
          />
          <Route
            path="/invoices/versions/:id"
            element={
              <MainLayout>
                <Version key="invoices" />
              </MainLayout>
            }
          />
          <Route
            path="/receipts/versions/:id"
            element={
              <MainLayout>
                <Version key="receipts" />
              </MainLayout>
            }
          />
          <Route
            path="/sales/versions/:id"
            element={
              <MainLayout>
                <Version key="sales" />
              </MainLayout>
            }
          />
          <Route
            path="/creditcardstatements/versions/:id"
            element={
              <MainLayout>
                <Version key="creditcardstatements" />
              </MainLayout>
            }
          />
          <Route
            path="/bank-statements/versions/:id"
            element={
              <MainLayout>
                <Version key="bank-statements" />
              </MainLayout>
            }
          />
          <Route element={<Navbar />}>
            <Route
              path="/invoice/:id"
              element={<DocumentAnnotation key="invoices" />}
            />
            <Route
              path="/receipt/:id"
              element={<DocumentAnnotation key="receipts" />}
            />
            <Route
              path="/sale/:id"
              element={<DocumentAnnotation key="sales" />}
            />
            <Route
              path="/creditcardstatement/:id"
              element={<DocumentAnnotation key="creditcardstatements" />}
            />
            <Route
              path="/bank-statement/:id"
              element={<DocumentAnnotation key="bank-statements" />}
            />
            <Route
              path="/invoice/:version/:id"
              element={<DocumentAnnotation key="invoices" />}
            />
            <Route
              path="/receipt/:version/:id"
              element={<DocumentAnnotation key="receipts" />}
            />
            <Route
              path="/sale/:version/:id"
              element={<DocumentAnnotation key="sale" />}
            />
            <Route
              path="/creditcardstatement/:version/:id"
              element={<DocumentAnnotation key="creditcardstatements" />}
            />
            <Route
              path="/bank-statement/:version/:id"
              element={<DocumentAnnotation key="bank-statements" />}
            />
          </Route>
          <Route
            path="/settings"
            element={
              <MainLayout>
                <Setting />
              </MainLayout>
            }
          />
          <Route
            path="/flow-configuration"
            element={
              <MainLayout>
                <FlowConfiguration />
              </MainLayout>
            }
          />
          <Route
            path="/flow-configuration/editor"
            element={
              <MainLayout>
                <FlowConfigurationEditor />
              </MainLayout>
            }
          />
          <Route
            path="/log-dashboard/:flowId"
            element={
              <MainLayout>
                <LogDashboard />
              </MainLayout>
            }
          />
          <Route
            path="/help"
            element={
              <MainLayout>
                <TermsOfService />
              </MainLayout>
            }
          />
          <Route
            path="/support"
            element={
              <MainLayout>
                <Support />
              </MainLayout>
            }
          />
        </Route>
        <Route element={<ProtectedRouteForAdmin />}>
          <Route
            path="/admin-dashboard"
            element={
              <MainLayout>
                {/* <AdminDashboard /> */}
                <AdminDashboardNew />
              </MainLayout>
            }
          />
        </Route>

        <Route element={<ProtectedRouteForAllRole />}>
          <Route
            path="/notifications"
            element={
              <MainLayout>
                <Notification />
              </MainLayout>
            }
          />
          <Route
            path="/account-info"
            element={
              <MainLayout>
                <AccountInfoTabSection />
              </MainLayout>
            }
          />
        </Route>

        <Route element={<ProtectedRouteForSalesAdmin />}>
          <Route
            path="/sales-admin-dashboard"
            element={
              <MainLayout>
                <SalesAdminDashboard />
              </MainLayout>
            }
          />
        </Route>
        <Route element={<ProtectedRouteForSalesAdmin />}>
          {/* <Route
            path="/sales-dashboard"
            element={(
              <MainLayout>
                <SalesDashboard />
              </MainLayout>
            )}
          /> */}
        </Route>
        <Route element={<ProtectedRouteForSA />}>
          <Route
            path="/payment"
            element={
              <MainLayout>
                <Payment />
              </MainLayout>
            }
          />
          <Route
            path="/my-account"
            element={
              <MainLayout>
                <MyAccount />
              </MainLayout>
            }
          />
          <Route
            path="/SA-help"
            element={
              <MainLayout>
                <Help />
              </MainLayout>
            }
          />
          <Route
            path="/dashboard"
            element={
              <MainLayout>
                <SalesReport />
              </MainLayout>
            }
          />
          <Route
            path="/subscriber"
            element={
              <MainLayout>
                <Subscriber />
              </MainLayout>
            }
          />
          <Route
            path="/my-team"
            element={
              <MainLayout>
                <SuperManager />
              </MainLayout>
            }
          />
          <Route
            path="/scan-history"
            element={
              <MainLayout>
                <OrganizationScanHistory />
              </MainLayout>
            }
          />
          <Route
            path="/subscription-plan"
            element={
              <MainLayout>
                <SubscriptionPlan />
              </MainLayout>
            }
          />
          <Route
            path="/activity-history"
            element={
              <MainLayout>
                <ActivityHistory />
              </MainLayout>
            }
          />
          <Route
            path="/accuracy-details/:docType"
            element={
              <MainLayout>
                <AccuracyDetails />
              </MainLayout>
            }
          />
          <Route
            path="/SA-support"
            element={
              <MainLayout>
                <Support />
              </MainLayout>
            }
          />
          {/* <Route
              path="/user-activity-history"
              element={(
                <MainLayout>
                  <UserActivityHistory />
                </MainLayout>
              )}
            /> */}
        </Route>

        <Route element={<ProtectedRouteForOtp />}>
          <Route path="/otp-auth" element={<OtpSection />} />
        </Route>

        <Route path="/chart" element={<AccountChart />} />

        <Route path="*" element={<PageNotFound />} />

        <Route element={<ProtectedRouteForLoggedInUser />}>
          <Route path="/login" element={<Login />} />
        </Route>

        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/addUser/:token" element={<AddUsers />} />
        <Route path="/addNewMembersSASide/:token" element={<AddUsers />} />
        <Route path="/register" element={<Register />} />
      </Routes>
    </MainRoot>
  </BrowserRouter>
);

export default Router;
